import { sleep } from '@ipfabric/ui-components/utils/sleep';
import type { PacketDetailPreviousButtonClickEvent } from 'components/DeviceView/DeviceViewContent/PacketDetail/PacketDetail';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { selectSelectedFirstPacketId } from 'components/Graph/model/selectors/pathInspector/selectSelectedFirstPacketId';
import { setPacketTracingPackets } from '../pathLookup/setPacketTracingPackets';
import { animateNode } from './animateNode';
import { getIncomingEdgeIds } from './helpers/getIncomingEdgeIds';
import { getPathInspectorTabToResetData } from './helpers/getPathInspectorTabToResetData';
import { resetPathInspectorTab } from './resetPathInspectorTab';

export const pathLookupDetailPreviousButtonClick: GraphCommandFactory<
  PacketDetailPreviousButtonClickEvent
> = (cmdContext, dispatch) => async (command) => {
  const { currentDeviceViewEntity, followingNode } =
    getPathInspectorTabToResetData(
      command.edgeId,
      'source',
      cmdContext.getState().graph,
      cmdContext.getDeviceView(),
    );
  const incomingEdgeIds = getIncomingEdgeIds(
    cmdContext.getState(),
    command.edgeId,
    followingNode?.id,
  );
  const successorPacketId = selectSelectedFirstPacketId(cmdContext.getState());

  dispatch(resetPathInspectorTab, {
    currentDeviceViewEntity,
    edgeId: command.edgeId,
    edgesToUnhighlight: [
      command.edgeId,
      ...(incomingEdgeIds !== undefined ? incomingEdgeIds : []),
    ],
    followingNode,
    nodeSn: command.nodeSn,
    selectedIncomingEdgeId:
      incomingEdgeIds?.length === 1 ? incomingEdgeIds[0] : undefined,
    selectedOutgoingEdgeId: command.edgeId,
  });
  if (successorPacketId !== null) {
    // Wait for path inspector node update.
    // Active node, highlighlighted and selected packets are changed.
    // Then can be set successor packet.
    await sleep(0);
    dispatch(setPacketTracingPackets, { successorPacketId });
  }

  dispatch(animateNode, {
    currentNodeSn: command.nodeSn,
    followingNodeSn: followingNode?.sn,
  });
};
